import { topicItems } from "@/mocks/homeData";

const colorMap: Record<string, string> = {
  accent: "bg-accent-100 text-accent-700 hover:bg-accent-200",
  primary: "bg-primary-100 text-primary-700 hover:bg-primary-200",
  secondary: "bg-secondary-100 text-secondary-700 hover:bg-secondary-200",
};

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
            热门话题
          </h2>
          <p className="text-sm text-foreground-500 mt-3 max-w-xl mx-auto">
            大家都在讨论的影视话题，加入交流发现更多好片
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topicItems.map((topic) => (
            <div
              key={topic.id}
              className={`group px-5 py-3 rounded-full text-sm font-medium cursor-pointer transition-all whitespace-nowrap flex items-center gap-2 ${colorMap[topic.color] || colorMap.primary}`}
            >
              <span>{topic.name}</span>
              <span className="text-[11px] opacity-70">{topic.heat}</span>
              <i className="ri-arrow-right-line text-xs opacity-0 group-hover:opacity-100 transition-opacity -ml-1"></i>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}